module.exports = __webpack_public_path__ + "img/pic_300296.2dbf5b23.jpg";